import React from 'react'
import PropTypes from 'prop-types'

const MultiSelect = props => {
  return (
    <div className="form-row flex-column">
      <div className="form-label">
        <div className="d-flex align-items-center">
          {props.bulkSelect ? (
            <input
              type="checkbox"
              className=" ml-4 pointer"
              onChange={props.onBulkSelect}
            />
          ) : null}
          <h3 className="mt-2 mb-2 ml-4 text-dark">{props.label}</h3>
        </div>
        <hr className="m-0" />
      </div>
      <div className="field">
        <div className="field-container">
          {props.contentArray.map((entry, index) => {
            const bgHighlight = entry.checked ? 'bg-turquoise-green' : ''
            return (
              <label
                className={`d-block py-2 pointer ${bgHighlight} ${props.multiSelectClass}`}
                key={index}
              >
                <span className="pl-4 py-2 d-flex align-items-center">
                  <input
                    name="multiselect-item"
                    checked={entry.checked}
                    onChange={props.onSelected}
                    value={entry.id}
                    type="checkbox"
                    className="pointer"
                  />
                  <span className="ml-3" />
                  {entry.name}
                  <br />
                </span>
              </label>
            )
          })}
        </div>
      </div>
    </div>
  )
}

MultiSelect.propTypes = {
  contentArray: PropTypes.array.isRequired,
  label: PropTypes.string.isRequired,
  onSelected: PropTypes.func,
  multiSelectClass: PropTypes.string,
  bulkSelect: PropTypes.bool,
  onBulkSelect: PropTypes.func,
}

MultiSelect.defaultProps = {
  multiSelectClass: '',
  bulkSelect: false,
  onBulkSelect: null,
}

export default MultiSelect
